import { CurriculumGoals } from "./CurriculumGoals";

export const CurriculumGoalsContainer = () => {
  return <CurriculumGoals />;
};
